// extracted by mini-css-extract-plugin
export var container = "styles-module--container--1LAMV";
export var text = "styles-module--text--30n3N";